import SpotifyService from 'spotify-web-api-js';
export default new SpotifyService();
